import { useState, useEffect, useRef } from "react";

export const useCountUp = (
  target: number,
  suffix: string = "",
  threshold: number = 0.5
): [React.RefObject<HTMLDivElement | null>, string] => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [display, setDisplay] = useState("0" + suffix);
  const hasAnimated = useRef(false);
  const prevTarget = useRef(target);

  // Reset animation flag when target changes
  if (prevTarget.current !== target) {
    prevTarget.current = target;
    hasAnimated.current = false;
  }

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true;
            let current = 0;
            const increment = Math.ceil(target / 60);
            const timer = setInterval(() => {
              current += increment;
              if (current >= target) {
                current = target;
                clearInterval(timer);
              }
              setDisplay(current + suffix);
            }, 30);
          }
        });
      },
      { threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [target, suffix, threshold]);

  return [ref, display];
};
